import "@hakili/ui/styles.css";

import { createRoot } from "react-dom/client";

import { App } from "./App.js";

/**
 * The entry point of `console-web`, `P0-UIK-020` and now `P0-UIK-021`.
 *
 * **What changed, and why the file did not.** `020`'s scope was *"a bundler, an
 * entry point and a `build` script per app"*, and it deliberately mounted an
 * empty root: inventing `ConsoleShell`'s required props there would have been
 * writing product inside an infrastructure item. It said the body would be
 * replaced when the screens' item landed , *"not this file's existence"* , and
 * this is that replacement.
 *
 * Everything above the DOM lives in `App`, which is why this remains five
 * lines: a test can render `App` with a stub `fetch` and never touch a document.
 */
const racine = document.querySelector("#racine");
if (racine === null) {
  // Not a silent no-op: a missing mount point means the entry document and the
  // entry script disagree, and the page would be blank with nothing in the
  // console to say why.
  throw new Error("racine introuvable");
}

/**
 * The API origin, substituted as a literal at build time.
 *
 * `packages/config/vite` refuses a build that has no `VITE_API_ORIGIN`, by
 * name, so this cannot be empty in anything a host serves. Reading it here and
 * passing it down means `App` takes an origin as a prop and a spec can give it
 * one , no module in this app reads the environment except this line.
 */
createRoot(racine).render(
  <App
    origin={import.meta.env.VITE_API_ORIGIN}
    expertOrigin={import.meta.env.VITE_EXPERT_ORIGIN}
    clientOrigin={import.meta.env.VITE_CLIENT_ORIGIN}
  />,
);
